import AwsS3Multipart from "@uppy/aws-s3-multipart";
import Uppy from "@uppy/core";
import "@uppy/core/dist/style.css";
import Dashboard from "@uppy/dashboard";
import "@uppy/dashboard/dist/style.css";

export default function addAutomatedCoverageModal(el, props) {
  let $el = $(el);

  const form = el.querySelector("form");
  const urlsErrors = el.querySelector("#urls-errors");
  const dashboard = el.querySelector("#automated-coverage-upload-dashboard");
  const uploadedInputs = el.querySelector("#automated-coverage-uploaded-urls");
  const submit = form.querySelector('input[type="submit"]');
  let uploader;

  function refreshUploads() {
    uploadedInputs.replaceChildren();
    const files = uploader.getFiles();
    files.forEach((file) => {
      if (!file.uploadURL || !file.progress.uploadComplete) return;
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "automated_coverage_items_form[uploaded_urls][]";
      input.value = file.uploadURL;
      uploadedInputs.appendChild(input);
    });
    submit.disabled = files.some((file) => !file.progress.uploadComplete);
  }

  if (dashboard) {
    uploader = Uppy({
      id: "automated-coverage-uploader",
      autoProceed: true,
      restrictions: {
        allowedFileTypes: [
          ".mp3",
          ".mp4",
          ".m4a",
          ".wav",
          ".ogg",
          ".webm",
          ".flac",
          ".mov",
        ],
        maxFileSize: 150 * 1024 * 1024,
        maxNumberOfFiles: 10,
      },
    });
    uploader.use(Dashboard, {
      target: dashboard,
      inline: true,
      width: "100%",
      height: 260,
      note: "MP3, MP4, M4A, WAV, OGG, WebM, FLAC or MOV",
      doneButtonHandler: null,
    });
    uploader.use(AwsS3Multipart, { limit: 2, companionUrl: "/" });
    [
      "file-added",
      "file-removed",
      "upload-success",
      "complete",
      "upload-error",
    ].forEach((event) => {
      uploader.on(event, refreshUploads);
    });
  }

  // Handle modal hide event
  $el.on("hidden.bs.modal", function () {
    // Reset form and clear errors
    form.reset();
    urlsErrors.innerHTML = "";
    if (uploader) {
      uploader.reset();
      refreshUploads();
    }
  });

  function destroy() {
    $el.off("hidden.bs.modal");
    if (uploader) uploader.close();
  }

  return {
    destroy: destroy,
  };
}
